import { useCallback } from 'react';

// Pendo has been removed - this hook is now a no-op
export const usePendo = () => {
  const initiatePendo = useCallback(() => {
    // No-op: Pendo integration removed
  }, []);

  return { initiatePendo };
};
